var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"list",staticClass:"list"},_vm._l((_vm.rows),function(action,index){return _c('card',_vm._b({key:index},'card',_vm.cardProps(action),false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }